/* NIVIA MAISON — scroller horizontal dos swatches no card de produto.
   As setas so aparecem quando a fila de swatches transborda o card. */
(function () {
  if (customElements.get('nm-swatch-scroller')) return;

  class NmSwatchScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.card__swatches-container');
      this.prev = this.querySelector('.card__swatches-arrow--prev');
      this.next = this.querySelector('.card__swatches-arrow--next');
      if (!this.track || !this.prev || !this.next) return;

      this.onScroll = this.update.bind(this);
      this.prev.addEventListener('click', () => this.scrollByStep(-1));
      this.next.addEventListener('click', () => this.scrollByStep(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      /* Sem ResizeObserver de proposito: nesta loja ele nao entrega callback
         nenhum (nem a notificacao inicial do observe()), provavelmente por
         throttle depois de um loop de RO disparado por outro script do tema.
         Os gatilhos abaixo cobrem os casos reais sem depender dele. */
      window.addEventListener('resize', this.onScroll);
      window.addEventListener('load', this.onScroll);

      /* As fotos das variantes carregam depois do connectedCallback e mudam
         a largura da fila — sem isto a primeira medicao sai errada. */
      this.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', this.onScroll, { once: true });
        img.addEventListener('error', this.onScroll, { once: true });
      });

      this.update();
      requestAnimationFrame(() => this.update());
      this.revealSelected();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('load', this.onScroll);
    }

    /* Rola aproximadamente tres swatches por clique. */
    scrollByStep(direction) {
      const swatch = this.track.querySelector('.color-swatch:not(.hidden)');
      const step = swatch ? swatch.getBoundingClientRect().width + 8 : 40;
      this.track.scrollBy({ left: direction * step * 3, behavior: 'smooth' });
    }

    /* Deixa o swatch marcado visivel ao carregar, sem animar a pagina. */
    revealSelected() {
      const checked = this.track.querySelector('input:checked');
      if (!checked) return;
      const swatch = checked.closest('.color-swatch');
      if (!swatch) return;
      const trackBox = this.track.getBoundingClientRect();
      const box = swatch.getBoundingClientRect();
      if (box.left < trackBox.left || box.right > trackBox.right) {
        this.track.scrollLeft = swatch.offsetLeft - this.track.clientWidth / 2 + swatch.clientWidth / 2;
      }
    }

    update() {
      /* Tolerancia de alguns pixels: arredondamento de sub-pixel fazia a
         seta aparecer com a fila inteira ja visivel. */
      const TOLERANCE = 8;
      const overflow = this.track.scrollWidth - this.track.clientWidth;
      const overflowing = overflow > TOLERANCE;
      this.toggleAttribute('data-overflowing', overflowing);

      if (!overflowing) {
        this.prev.hidden = true;
        this.next.hidden = true;
        return;
      }

      const left = this.track.scrollLeft;
      this.prev.hidden = left <= 1;
      this.next.hidden = left >= overflow - 1;
    }
  }

  customElements.define('nm-swatch-scroller', NmSwatchScroller);
})();
